const POSTED_DATE_OPTIONS = ['This month', 'This year'];
const SORTING_OPTIONS = [
  {
    display: 'Relevance',
    value: undefined,
  },
  {
    display: 'Publication date',
    value: 'publication_date',
  },
];

const NEWS_PATH = '/news';
const NEWS_AUTHOR_PATH = NEWS_PATH + '/authors';

export { POSTED_DATE_OPTIONS, SORTING_OPTIONS, NEWS_PATH, NEWS_AUTHOR_PATH };
